import React, { useMemo } from 'react';

import { PasswordUpdatePopup } from '../../componentsV2';
import { useAuth } from '../../hooks';
import { UseAuth } from '../../interfaces/hooks';

import { Background, Container } from './actionRequiredToAccessPlatform.styled';
import { KrkVerificationForm, MissingProfileData } from './screens';

export const ActionRequiredToAccessPlatformView: React.FC = (): JSX.Element => {
  const { userData, appSettings }: UseAuth = useAuth();

  // TODO: add types after login request available in types package
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const firstRequiredAction: any = useMemo(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (): any => userData?.requiredActions?.[0],
    [userData?.requiredActions]
  );

  return (
    <Container>
      {firstRequiredAction ? (
        firstRequiredAction.type === 'setPrivateEmail' ? (
          <MissingProfileData data={firstRequiredAction.data} formType={firstRequiredAction.type} />
        ) : (firstRequiredAction.type === 'fillForm' && firstRequiredAction.data.type === 'krk') && (
          <KrkVerificationForm formId={firstRequiredAction.data.id} />
        )
      ) : !!appSettings?.passwordExpirationInfo?.forceChange && (
        <>
          <PasswordUpdatePopup isActive />
          <Background />
        </>
      )}
    </Container>
  );
};
